import React, {useEffect, useRef, useState, useCallback,forwardRef, useImperativeHandle } from "react";
import Crop from "./Crop";
import { getCroppedImg } from "./CropUtils";
import {dataURLtoFILE} from "./functions";

const Croppers = forwardRef(({fileObject,getFile},ref) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [size, setSize] = useState({ width: 900, height: 300 });
    const [file, setFile] = useState(null);
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);
    useEffect(() => {
        getLocalFile();
    },[])
    const getLocalFile = async (e) => {
            let imageUrl = await readFile(fileObject);
            setFile(imageUrl);
    };
    const readFile = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.addEventListener("load", () => resolve(reader.result), false);
            reader.readAsDataURL(file);
        });
    };
    const onCropComplete = useCallback(async (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    const getImage = useCallback(async () => {
        try {
            const croppedImage = await getCroppedImg(
                file,
                croppedAreaPixels,
            );
            setCroppedImage(croppedImage);
            getFile(dataURLtoFILE(croppedImage, 'cropped.jpg'));
        } catch (e) {
            console.error(e);
        }
    });
    useImperativeHandle(ref,
        () => ({sendObjectFile() {getImage()}}),
     )
    return (
        <>
            <Crop
                image={file}
                crop={crop}
                zoom={zoom}
                aspect={2 / 1}
                cropSize= {size}
                objectFit="horizontal-cover"
                onCropChange={setCrop}
                onCropSizeChange={setSize}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
            />
        </>
    );
});

export default Croppers;
